module.exports = __webpack_public_path__ + "img/casedrive-logo.31f58904.svg";